import { TextContent } from './TextContent'

import * as styles from './ClampingTextContentNodeClamp.module.css'

function ClampingTextContentNodeClamp({
  Tail,
  clamped,
  className = styles.ClampingTextContentNodeClamp,
  containerRef,
  content,
  fullText,
  measureRef,
  rootRef,
  tailRef,
  textClassName = styles.text,
  textRef,
  ...clampingConfig
}) {
  return (
    <div className={className} ref={rootRef}>
      <TextContent
        Tail={Tail}
        className={styles.measureContainer}
        containerRef={measureRef}
        content={fullText}
        tailClassName={styles.tail}
        tailProps={clampingConfig}
        tailRef={tailRef}
        textClassName={textClassName}
        textRef={textRef}
      />
      <TextContent
        Tail={Tail}
        className={styles.textContainer}
        containerRef={containerRef}
        content={clamped ? content : fullText}
        tailClassName={styles.tail}
        tailProps={clampingConfig}
        textClassName={textClassName}
      />
    </div>
  )
}

export default ClampingTextContentNodeClamp
